/**
 * Atlas Design Tokens — Re-export hub
 *
 * All tokens are defined in their respective layer files:
 *   primitives/ — raw values
 *   semantic/   — CSS var references for components
 *   domain/     — data-driven display colors
 */

// ── Primitives (raw values, used by themes and direct hex needs) ────────────
export { colorPrimitives } from "./primitives/colors";
export { spacingValues } from "./primitives/spacing";
export {
  fontFamily,
  fontSizeValues,
  fontWeightValues,
  lineHeightValues,
  letterSpacingValues,
} from "./primitives/typography";
export { borderRadiusValues } from "./primitives/shape";
export { durationValues, easing } from "./primitives/animation";
export { opacityValues } from "./primitives/opacity";
export {
  layoutValues,
  breakpointValues,
  componentBreakpointValues,
  breakpointHeightValues,
  zIndex,
  iconSize,
  type IconSize,
} from "./primitives/layout";

// ── Semantic (CSS var references — use these in components) ─────────────────
export { text, surface, border, interactive, status, brand, nav, footer } from "./semantic/colors";
export { spacing } from "./semantic/spacing";
export { fontSize, controlFontSize, fontWeight, lineHeight, letterSpacing } from "./semantic/typography";
export { borderRadius } from "./semantic/shape";
export { shadow } from "./semantic/shadows";
export { duration, transition } from "./semantic/animation";
export { opacity } from "./semantic/opacity";
export { layout, breakpoints, mediaAbove, mediaBelow } from "./semantic/layout";
export { focusRing } from "./semantic/focusRing";

// ── Domain (data-driven display colors, not themed) ─────────────────────────
export { rankings } from "./domain/rankings";
export { dataChipColors, dataVizClassification, dataVizClassificationPalette } from "./domain/dataChips";

// ── Data Visualization ──────────────────────────────────────────────────────
/** Static (non-themed) data viz constants */
export const dataViz = {
  neutral: "#808080",
  strokeGray: "#808080",
  strokeLightGray: "#b3b3b3",
  gridline: "#e6e6e6",
  overlay: "rgba(0, 0, 0, 0.3)",
  overlayLight: "rgba(0, 0, 0, 0.1)",
  arrowPositive: "#f1c086",
  arrowNegative: "#8fd8e5",
  sortArrowUnselected: "#d6d6d6",
  unfocused: "#d6d6d6",
  textDark: "#333333",
  textSecondary: "#666666",
  axisText: "#232323",
  growthPositive: "#f1c086",
  growthNegative: "#8fd8e5",
  tableRowHover: "#efefef",
  tooltipHeader: "#d7dbdd",
  lightBorder: "#dcdcdc",
  backgroundDark: "#2e353f",
  backgroundMedium: "#e6e7e8",
  loadingBackground: "#7f8c8d",
  primaryAction: "#334c60",
  primaryActionHover: "#2a3f50",
  accentBlue: "#5065a8",
} as const;

/** @deprecated Use `layout.pageMargin` */
export const rootFontSize = 16;
